import * as angular from 'angular';

import {
  Input,
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import {
  Traveler,
} from 'types';

import { AuthService } from 'services/auth.service';
import { CartService } from 'services/cart.service';
import { SearchService } from 'services/search.service';
import { ProductService } from 'services/product.service';
import { EcommerceService } from 'services/ecommerce.service';
import { VisaProcessingService } from './visa-processing.service';
import { EtomsService } from 'services/etoms.service';
import { PopulateService } from 'services/populate.service';

import visaProcessingHtml from './visa-processing.html';
import './visa-processing.scss';



@Component({
  selector: 'gw-visa-processing',
  template: visaProcessingHtml,
  providers: [VisaProcessingService],
})
export class VisaProcessingComponent implements OnInit {
  public laroute = (<any>window).laroute;
  public cart: any;
  public product: any;
  public state = {
    submitting: false,
  };
  private search: any;

  @Input() productId: string;
  @Input() domain: string

  constructor(
    @Inject('$filter') private $filter,
    @Inject(AuthService) private authService: AuthService,
    @Inject(CartService) private cartService: CartService,
    @Inject(SearchService) private searchService: SearchService,
    @Inject(ProductService) private productService: ProductService,
    @Inject(EcommerceService) private ecommerceService: EcommerceService,
    @Inject(VisaProcessingService) private visaProcessingService: VisaProcessingService,
    @Inject(EtomsService) private etomsService: EtomsService,
    @Inject(PopulateService) protected populateService: PopulateService,
  ) {}

  async ngOnInit() {
    const cartRequest = this.cartService.getCart();
    const search = this.searchService.getSearch();

    if (search.rows[0].params['residency'].code === '') {
      search.rows[0].params['residency'].code = await this.getDefaultResidency();
    }

    const productRequest = this.productService.getProduct(
      this.productId,
      search.rows[0].params['citizenship'].code,
      search.rows[0].params['residency'].code);
    [this.product, this.cart] = [await productRequest, await cartRequest];

    // Build travelers from search or cart
    this.search = this.searchService.getSearch();
    const amount = this.search.travelers.adults + this.search.travelers.children;
    this.visaProcessingService
      .updateTravelers(this.cart.travelers, amount, this.search.rows[0].params);
  }

  addTraveler() {
    this.visaProcessingService.addTraveler(this.search.rows[0].params);
  }

  removeTraveler(index: number) {
    this.visaProcessingService.removeTraveler(index);
  }

  disableAddToCart(): boolean {
    if (!this.cart) return true;

    const unconfirmed = this.visaProcessingService.travelers
      .findIndex(traveler => !traveler.confirmed);

    const required = this.visaProcessingService.travelers
      .findIndex(traveler => traveler.required);

    return (unconfirmed > -1) || (required === -1) || this.state.submitting;
  }

  viewCart() {
    window.location.assign(this.laroute.route('checkout.account'));
  }

  async addToCart() {
    this.state.submitting = true;

    // Add destination to itinerary
    const search = this.searchService.getSearch();
    const destination = search.rows
      .find(search => search.selected === this.product.country);

    const itineraryItem = {
      id: 'i' + Math.floor(Math.random() * 1000).toString(),
      dates: destination ? destination.dates : null,
      productId: this.product.uuid,
      country: this.product.country,
    };

    this.cart.itinerary.destinations[itineraryItem.id] = itineraryItem;

    // Add product to cart
    this.cart.products[this.product.uuid] = this.product;

    // Update travelers to cart if they don't exist already
    this.visaProcessingService.travelers
      .filter(traveler => traveler.required)
      .forEach((traveler: any) => {
        this.cart.travelers[traveler.id] = {
          id: traveler.id,
          name: traveler.name,
          citizenship: traveler.citizenship,
          residency: traveler.residency,
        };

        // Add options to cart
        this.cart.options[traveler.options.uuid] = traveler.options;

        let item = {
          type: 'visa',
          travelerId: traveler.id,
          productId: this.product.uuid,
          itineraryId: itineraryItem.id,
          optionsId: traveler.options.uuid,
          // outbound: traveler.outbound,
          requireShipping: this.product.require_shipping,
          chargeEmbassyFee: traveler.options.chargeEmbassyFee,
          addons: traveler.addons,
        };

        if (this.product.require_shipping) {
          item['outbound'] = traveler.outbound;
        }

        // Add order item to relate these data points
        this.cart.order.push(item);
      })
    ;

    // Ecommerce Add To Cart
    this.ecommerceService.addToCart(this.cart);

    try {
      const cart = await this.cartService.saveCart(this.cart);

      if (cart) {
        this.state.submitting = false;
        window.location.assign(this.laroute.route('checkout.account'));
      }
    } catch (e) {
      this.state.submitting = false;
      throw e;
    }
  }

  /**
   * Get the default residency by ip location
   */
  async getDefaultResidency() {
    return this.populateService.getDefaultState()
      .then((response) => {
        // set the default state to NY if the user is outside US
        if (response['status'] !== 'success' || response['data']['country'] !== 'US') {
          return 'NY';
        }
        return response['data']['region_code'];
      })
      .catch((error) => { return 'NY'; });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/visa-processing/visa-processing.component.ts